export default __webpack_public_path__ + "static/media/prensesselin.37983ad0.jpg";